//@ts-check
import React from 'react';
import request from '../../../utils/request';
import store from '../../../store';
import ACTIONS from '../../../store/actions';
import DataAction from '../../actions';
import Modals from '../../../modal';
import Placeholders from '../../../formatter/Placeholders';
/**@type {import('../types').DataType<import('./types').ListContactDataModel>} */

var LIST_CONTACT_DATA_TYPE = {
  extends: 'contact',
  data: {
    url: '/backend/listcontacts/{listId}/cache',
    filterUrlKey: 'searchName',
    onBeforeRequest: function onBeforeRequest(options, request) {
      if (request.type === 'loadView') {
        if (options.dataProps) {
          var url = request.url;
          if (options.dataProps.listId) url = url.replace('{listId}', options.dataProps.listId);else if (options.dataProps.listPreview) url = "/backend/listcontacts/cache?name=".concat(options.dataProps.listPreview);
          return {
            url: url
          };
        }
      }
    }
  },
  contextMenu: [{
    type: 'open'
  }, 'separator', {
    id: 'removeFromList',
    label: 'Remove From List',
    onClick: function onClick(e, data, config) {
      var listId = config.dataProps.listId;
      var contactId = data.Id;
      Modals.open({
        type: Modals.TYPES.DELETE_CONFIRMATION,
        props: {
          title: 'Remove From List',
          message: React.createElement(React.Fragment, null, React.createElement(Placeholders, {
            template: "Are you sure you want to remove \u201C{label}\u201D ",
            dataType: "contact",
            id: contactId
          }), React.createElement(Placeholders, {
            template: "from \u201C{label} list\u201D?",
            dataType: "list",
            id: listId
          })),
          submitLabel: 'Remove',
          submittingLabel: 'Removing...',
          onDelete: function onDelete() {
            var contactDataMarker = {
              id: contactId,
              dataKey: config.view.dataKey,
              idKeyProp: config.idKeyProp
            };
            store.dispatch({
              type: ACTIONS.ITEM_DELETE,
              data: contactDataMarker
            });
            return request({
              method: 'DELETE',
              url: "/backend/lists/".concat(config.dataProps.listId, "/").concat(data.Id)
            }).then(function () {
              return DataAction.grid({
                id: config.view.id
              }).refresh().then(function () {
                setTimeout(function () {
                  //show feedback with 10s timeout
                  store.dispatch({
                    type: ACTIONS.ITEM_DELETE_FAILED,
                    data: contactDataMarker
                  });
                }, 10000);
                /*  
                contacts from a list are read from a cache file => update cache is not finished => 
                implement autoRefresh (see EOS)
                */

                return DataAction.grid({
                  id: config.view.id
                }).refresh();
              });
            }).catch(function (e) {
              store.dispatch({
                type: ACTIONS.ITEM_DELETE_FAILED,
                data: contactDataMarker
              });
              throw e;
            });
          }
        }
      });
    }
  }]
};
export default LIST_CONTACT_DATA_TYPE;